import { Button } from "@/components/ui/button";
import { CompanyUser } from "@/schema/CompanyUser";
import AddMemberDialog from "@/src/console/(auth)/companies/[id]/_components/AddMemberDialog";
import DeleteMemberDialog from "@/src/console/(auth)/companies/[id]/_components/DeleteMemberDialog";
import EditMemberDialog from "@/src/console/(auth)/companies/[id]/_components/EditMemberDialog";
import MemberTable from "@/src/console/(auth)/companies/[id]/_components/MemberCard/MemberTable";
import ResetMemberPasswordDialog from "@/src/console/(auth)/companies/[id]/_components/ResetMemberPasswordDialog";
import useMemberDialog from "@/src/console/(auth)/companies/[id]/_hooks/useMemberDialog";
import { useTranslation } from "react-i18next";

interface MemberCardProps {
  members: CompanyUser[];
  companyId: number;
}

function MemberCard({ members, companyId }: MemberCardProps) {
  const { t } = useTranslation();
  const { setDialog } = useMemberDialog();

  return (
    <div className="my-card">
      <div className="flex items-center justify-between px-6 py-5">
        <div className="text-lg font-medium text-cool-gray-900">
          {t("company-members")}
        </div>
        <Button onClick={() => setDialog({ type: "add", member: undefined })}>
          {t("add-member")}
        </Button>
      </div>
      <MemberTable members={members} />
      <AddMemberDialog companyId={companyId} />
      <EditMemberDialog companyId={companyId} />
      <ResetMemberPasswordDialog />
      <DeleteMemberDialog companyId={companyId} />
    </div>
  );
}

export default MemberCard;
